export default {
    // 模块名称
    carPatrol: {
        // 按钮类
        button: {
            create: '创建布控',
            delete: '删除布控',
            start: '启用布控',
            disable: '禁用布控',
            query: '查询',
            reset: '重置',
            confirm: '确定',
            cancel: '取消',
            back: '返回',
            Enabled: '启用',
            Disabled: '禁用',
            limit: '不限',
            submit: '提交'
        },
        // 文字标签类
        label: {
            name:'布控名称',
            state:'布控状态',
            time:'布控时间',
            people:'布控人',
            type:'布控类型',
            groups:'布控名单组',
            blacklist:'黑名单',
            timeQuantum:'布控时段',
            select:'选择',
            number:'序号',
            blacklistName:'黑名单组名称',
            cameraGroups: '布控摄像机组',
            carList: '车辆列表信息',
            carer: '车主',
            carNo: '车牌号',
            carType: '车型',
            carColor: '车身颜色',
            nodata: '暂无数据',
            to: '至',
            blackGroup: '黑名单组',
            week: '周',
            oneDay: '周一',
            twoDay: '周二',
            threeDay: '周三',
            fourDay: '周四',
            fiveDay: '周五',
            satDay: '周六',
            sunDay: '周日',
            object:'布控对象'
        },
        // 提示类
        placeholder: {
            modification: '修改',
            delete: '删除',
            disable: '禁用',
            enabled:'启用',
            details:'详情',
            name:'请输入布控名称',
            state:'请选择布控状态',
            unlimited:'不限',
            blackGroup:'请输入黑名单组名称',
            chooseBlack:'请选择黑名单组',
            chooseTime:'请选择布控时段',
            length:'长度在 1 到 50 个字符',
            nameIno:'布控名称不合法，应为中文、英文、数字组合'
        },
        // 消息类
        message: {
            unableDelete:'任务启用中，无法删除',
            deleteWarn:'此操作将永久删除该任务, 是否继续?',
            deleteOk:'删除成功',
            deleteNo:'删除失败',
            deleteStarting:'选中的任务有启用中的任务，无法删除！',
            startWarn:'此操作将启用布控任务, 是否继续?',
            disableWarn:'此操作将禁用布控任务, 是否继续?',
            starting:'选中的任务有启用的任务！',
            disableing:'选中的任务有禁用的任务！',
            someStart:'此操作将批量启用该任务, 是否继续?',
            someDisable:'此操作将批量禁用该任务, 是否继续?',
            someDelete:'此操作将批量删除该任务, 是否继续?',
            batchStart:'您还没有选择要批量启用的布控任务', //批量启用提醒
            batchDisable:'您还没有选择要批量禁用的布控任务', //批量禁用提醒
            batchDelete:'您还没有选择要批量删除的布控任务', //批量删除提醒
            name: '请输入布控名称',
            blacklistName: '请选择黑名单组',
            timeQuantum: '请选择布控时段'
        },
        // 标题类
        title: {
            remind:'提示',
            cancel:'取消',
            successStart:'启用成功',
            successDisable:'禁用成功',
            blackList:'黑名单选择',
            selectGroup:'已选择的黑名单组',
            selectCamera:'已选布控摄像机组',
            lookDetails: '详情',
            editControl: '修改布控',
            ControlTimeSelect: '布控时段选择',
        }
    }
}